import { useCallback } from 'react';
import { STORAGE_LOCALE } from 'constants/app-constants';

export const useLocales = () => {
  const getLocale = useCallback(
    () => window.localStorage.getItem(STORAGE_LOCALE) || 'en',
    [],
  );

  const setLocale = useCallback(
    lang => window.localStorage.setItem(STORAGE_LOCALE, lang),
    [],
  );
  return {
    getLocale,
    setLocale,
  };
};

export default {};
